import { colors } from "@mui/material";
import { PaymentInStatus } from "Domain/PaymentPlan/Entity/PaymentPlan";
import StatusChip from "./StatusChip";
import { useTranslation } from "react-i18next";

type PaymentInStatusProps = {
  status: PaymentInStatus;
};

const statusColors: Record<PaymentInStatus, string> = {
  INIT: colors.grey[500],
  AUTHORIZED: colors.blue[500],
  COLLECTED: colors.green[800],
  PARTIALLY_COLLECTED: colors.lightBlue[500],
  OVERPAID: colors.purple[500],
  UNPAID: colors.red[500],
};

export default function PaymentInStatusChip({ status }: PaymentInStatusProps) {
  const { t } = useTranslation();
  const statusColor = status in statusColors ? statusColors[status] : "white";

  return (
    <StatusChip
      color={statusColor}
      label={t(`STATUS.LABEL.payment_in.${status}`)}
      info={t(`STATUS.INFO.payment_in.${status}`)}
    />
  );
}
